var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{attrs:{"triggers":"hover","target":_vm.target,"title":_vm.title,"placement":_vm.placement,"delay":{ show: 0, hide: 0 }}})}
var staticRenderFns = []

export { render, staticRenderFns }